import { render, staticRenderFns } from "./psp-sn.vue?vue&type=template&id=a84b38b6&"
import script from "./psp-sn.vue?vue&type=script&lang=ts&"
export * from "./psp-sn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports